<template>
    <b-modal v-model="visibilityComputed" @hide="close" @show="show" scrollable size="xxl" :title="'Media Library|Bibliothèque multimédia'|tr"
             modal-class="e-file-library" body-class="p-0" :hide-footer="currentFile !== null || tabIndex > 0" no-close-on-backdrop>
        <b-tabs class="tabs-pills" v-model="tabIndex">
            <template v-if="!currentFile">
                <b-tab :title="'Library|Bibliothèque'|tr">
                    <e-browser v-model="fileSelected" :items="libraryFiltered" :default-id="extractedId" :fields="fields" @item-opened="onItemOpened" @item-dropped="onFileDropped"
                               title="Library|Bibliothèque" thumbnail="thumbnail" :translucent="false" header-variant="light" :key="1" no-rounded-border
                               delete-or-restore-url="/library/files/delete-or-restore" :api-options="{system_api: true}" context-auto show-trash show-default enable-trash
                               :initial-search="initialSearch" :search-keys="[`name`, `alt`, `description`, `permaLink`, `url`, `id`]">
                        <template #actions>
                            <b-input-group class="d-inline-flex w-auto ml-2" style="vertical-align: middle">
                                <b-input-group-text><i class="fas fa-folder"/></b-input-group-text>
                                <b-select v-model="filters.source">
                                    <option value="all" v-tr>All|Tous</option>
                                    <option value="branding" v-tr>Branding|Image de marque</option>
                                    <optgroup :label="tr(`Eye-Intelligence`)">
                                        <option value="eye-intelligence" v-tr>Eye-Intelligence</option>
                                        <option value="digital-signage" v-tr>Digital Signage|Affichage numérique</option>
                                        <option value="network-inventory" v-tr>Wi-Fi - Network Inventory|Wi-Fi - Inventaire réseau</option>
                                    </optgroup>
                                    <optgroup :label="tr(`Maps & Wayfinder|Plan et Wayfinder`)">
                                        <option value="map" v-tr>Map Photos|Photos de plans</option>
                                        <option value="map-layers" v-tr>Map Layers|Éléments de plans</option>
                                        <option value="map-virtual-visit" v-tr>Map Virtual Visit|Plan Visite Virtuelle</option>
                                        <option value="cms-website" v-tr>CMS - Website|CMS - Site internet</option>
                                        <option value="cms-items" v-tr>CMS - Items|CMS - Éléments</option>
                                        <option value="smart-link" v-tr>CMS - Smart Links|CMS - Lien Intelligent</option>
                                    </optgroup>
                                    <optgroup :label="tr(`Website|Site internet`)">
                                        <option value="website" v-tr>Website|Site internet</option>
                                        <option value="online-store" v-tr>Online Store|Magasin en ligne</option>
                                        <option value="blog" v-tr>Blog|Blog</option>
                                    </optgroup>
                                    <optgroup :label="tr(`IT Dashboard|Tableau de bord IT`)">
                                        <option value="it-systems" v-tr>IT - Systems|Systèmes TI</option>
                                        <option value="it-incidents" v-tr>IT - Incidents|Incidents TI</option>
                                    </optgroup>
                                    <optgroup :label="tr(`Customer|Client`)">
                                        <option value="documentation" v-tr>Documentation|Documentation</option>
                                        <option value="tickets" v-tr>Tickets|Tickets</option>
                                    </optgroup>
                                </b-select>
                            </b-input-group>

                            <b-select class="d-inline-flex w-auto ml-2" v-model="filters.category">
                                <option value="all" v-tr>All|Tous</option>
                                <option value="doc" v-tr>Documents</option>
                                <option value="image" v-tr>Images</option>
                                <option value="image-360" v-tr>360° Images|Images 360°</option>
                                <option value="icon" v-tr>Icon|Icône</option>
                                <option value="logo" v-tr>Logos</option>
                                <option value="avatar" v-tr>Avatars</option>
                                <option value="favicon" v-tr>Favicon</option>
                            </b-select>
                        </template>
                        <template #context="{item}">
                            <template v-if="item">
                                <b-dropdown-item v-if="item.category === 'image-360'" @click="previewFile(item)">
                                    <i class="fas fa-cube"/>
                                    <span v-tr >Preview 360|Aperçu 360</span>
                                </b-dropdown-item>
                                <b-dropdown-item v-else @click="previewFile(item)" target="_blank" class="context-menu-item" >
                                    <i class="fas fa-magnifying-glass"/>
                                    <span v-tr>Preview|Aperçu</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="renameModal = true" class="context-menu-item">
                                    <i class="fas fa-pen-field"/> <span v-tr>Rename|Renommer</span>
                                </b-dropdown-item>
                                <b-dropdown-divider/>
                            </template>
                        </template>
                        <template #field_size="{data}">
                            {{data|fileSize}}
                        </template>
                    </e-browser>

                    <b-modal v-if="renameModal && fileSelected" v-model="renameModal" :title="'Rename|Renommer'|tr" size="xs" modal-class="e-file-library-rename" body-bg-variant="white"
                         @ok="renameItem" :ok-title="`Rename|Renommer`|tr" @cancel="renameModal = false" :cancel-title="`Cancel|Annuler`|tr" @show="renameValue = fileSelected.name">
                        <b-form-group :label="tr(`Enter the new name for '|Entrez le nouveau nom pour '`) + fileSelected.name + `'`">
                            <e-input v-model="renameValue" trim/>
                        </b-form-group>
                    </b-modal>
                </b-tab>
                <b-tab :title="'Import|Importer'|tr" class="p-3">
                    <e-file-input ref="file" type="image" theme="light" @change="onNewUpload"/>
                    <hr>
                    <b-form-group :label="'Import from URL|Importer depuis une URL'|tr">
                        <b-input-group>
                            <b-input-group-text><i class="fas fa-globe"/></b-input-group-text>
                            <e-input type="url" v-model="customUrl" maxlength="2500" placeholder="Ex: https://image.eye-in.com"/>
                            <b-dropdown @click="urlToFile(customUrl)" variant="primary" split>
                                <template #button-content>
                                    <span v-tr>Import|Importer</span>
                                </template>
                                <b-dropdown-item @click="useURL(customUrl)">
                                    <i class="fas fa-link"/>
                                    <span v-tr>Use URL|Utiliser l'URL</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-input-group>
                    </b-form-group>
                </b-tab>
            </template>
            <b-tab v-if="currentFile && !isImportMultiple" :title="(newUpload ? 'Import New File|Importer un nouveau fichier' : 'Properties|Propriétés')|tr">
                <b-media class="m-3">
                    <template #aside>
                        <div v-if="loading" class="d-flex align-items-center justify-content-center" style="width: 200px; height: 200px">
                            <i class="fa-solid fa-spinner fa-spin-pulse"/>
                        </div>
                        <b-img v-else-if="newUpload" width="200" height="200" style="object-fit: contain" rounded :src="currentFile.thumbnail" @click="previewBase64Image(`Preview`, currentFile.thumbnailLarge)"/>
                        <e-file-input v-else :value="fileCopy.file" contain type="image" theme="light" @change="onUpdateFile"
                                      :default-image="fileCopy.thumbnail"  :image-style="{ width: '200px', height: '200px' }"/>
                    </template>
                    <b-form-group label-cols-md="3" :label="'Name|Nom'|tr">
                        <b-input-group>
                            <e-input maxlength="2500" :state="isFilenameValid" v-model="currentFile.name" @debounce="checkIfFileNameIsNotUsed" :debounce-time="500" />
                            <b-input-group-text>.{{currentFile.extension}}</b-input-group-text>
                        </b-input-group>
                        <e-form-tooltip variant="danger" v-if="!isFilenameValid">
                            <template v-if="!filenameIsAvailable">{{tr(`The filename is already in use|Le nom de fichier est déjà utilisé`)}}</template>
                            <template v-else-if="currentFile.name?.length < 1">{{tr(`The filename is required|Le nom de fichier est requis`)}}</template>
                            <template v-else>{{tr(`The filename is invalid|Le nom de fichier est invalide`)}}</template>
                        </e-form-tooltip>
                    </b-form-group>
                    <b-form-group v-if="isDealerParent() && $store.state.dealers" label-cols-md="3" :label="'Venue|Compte'|tr">
                        <e-dealer-select v-model="currentFile.dealerid"/>
                    </b-form-group>
                    <b-form-group label-cols-md="3" :label="'Category|Catégorie'|tr">
                        <b-select v-model="currentFile.category">
                            <option value="doc" v-tr>Documents</option>
                            <option value="image" v-tr>Images</option>
                            <option value="image-360" v-tr>360° Images|Images 360°</option>
                            <option value="icon" v-tr>Icon|Icône</option>
                            <option value="logo" v-tr>Logos</option>
                            <option value="avatar" v-tr>Avatars</option>
                            <option value="favicon" v-tr>Favicon</option>
                            <option value="default" v-tr>Other|Autre</option>
                        </b-select>
                    </b-form-group>
                    <b-form-group label-cols-md="3" :label="'Source|Source'|tr">
                        <b-input-group>
                            <b-input-group-text><i class="fas fa-folder"/></b-input-group-text>
                            <b-select v-model="currentFile.source">
                                <option value="branding" v-tr>Branding|Image de marque</option>
                                <optgroup :label="tr(`Eye-Intelligence`)">
                                    <option value="eye-intelligence" v-tr>Eye-Intelligence</option>
                                    <option value="digital-signage" v-tr>Digital Signage|Affichage numérique</option>
                                    <option value="network-inventory" v-tr>Wi-Fi - Network Inventory|Wi-Fi - Inventaire réseau</option>
                                </optgroup>
                                <optgroup :label="tr(`Maps & Wayfinder|Plan et Wayfinder`)">
                                    <option value="map" v-tr>Map Photos|Photos de plans</option>
                                    <option value="map-layers" v-tr>Map Layers|Éléments de plans</option>
                                    <option value="map-virtual-visit" v-tr>Map Virtual Visit|Plan Visite Virtuelle</option>
                                    <option value="cms-website" v-tr>CMS - Website|CMS - Site internet</option>
                                    <option value="cms-items" v-tr>CMS - Items|CMS - Éléments</option>
                                    <option value="smart-link" v-tr>CMS - Smart Links|CMS - Lien Intelligent</option>
                                </optgroup>
                                <optgroup :label="tr(`Website|Site internet`)">
                                    <option value="website" v-tr>Website|Site internet</option>
                                    <option value="online-store" v-tr>Online Store|Magasin en ligne</option>
                                    <option value="blog" v-tr>Blog|Blog</option>
                                </optgroup>
                                <optgroup :label="tr(`IT Dashboard|Tableau de bord IT`)">
                                    <option value="it-systems" v-tr>IT - Systems|Systèmes TI</option>
                                    <option value="it-incidents" v-tr>IT - Incidents|Incidents TI</option>
                                </optgroup>
                                <optgroup :label="tr(`Customer|Client`)">
                                    <option value="documentation" v-tr>Documentation|Documentation</option>
                                    <option value="tickets" v-tr>Tickets|Tickets</option>
                                </optgroup>
                            </b-select>
                        </b-input-group>

                        <div class="mt-3" v-if="newUpload">
                            <b-checkbox v-model="newUpload.showInLibrary">
                                <span v-tr>Add to the Library|Ajouter dans la bibliothèque</span>
                            </b-checkbox>
                        </div>
                    </b-form-group>
                    <b-form-group label-cols-md="3" :label="'Description'|tr">
                        <b-textarea v-model="currentFile.description"/>
                    </b-form-group>
                    <b-form-group label-cols-md="3">
                        <template #label>
                            <div class="d-flex align-items-center gap-1" >
                                <span>Alt</span>
                                <e-hint :text="`Alt text, is crucial for both SEO and accessibility.|Le texte Alt est essentiel pour le référencement et l'accessibilité.`|tr"/>
                            </div>
                        </template>
                        <b-input-group>
                            <e-input :required="altRequirement === `required`" :disabled="altRequirement === `disabled`" v-model="currentFile.alt"/>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols-md="3">
                        <template #label>
                            <div class="d-flex align-items-center gap-1" >
                                <span>{{'Permalink|Lien permanent'|tr}}</span>
                                <e-hint :text="`In SEO, permalink is used to create a legible and aesthetically pleasing links, making them easier for search engines to index and users to share.|Le lien permanent sert en SEO à créer des liens lisibles et esthétiques, facilitant leur indexation par les moteurs de recherche et leur partage par les utilisateurs.`|tr"/>
                            </div>
                        </template>
                        <b-input-group>
                            <b-input-group-text>/</b-input-group-text>
                            <!-- Disabled for now to help debugging -->
                            <e-input :required="permalinkRequirement === `required`" :state="isPermalinkValid" @debounce="checkIfPermaLinkIsNotUsed" :disabled="permalinkRequirement === `disabled`" :debounce-time="500" v-model="currentFile.permaLink" type="permaLink"/>
                            <template v-if="permalinkRequirement !== `disabled`">
                                <b-btn size="sm" variant="light" @click="syncPermaLinkWithFileName" v-b-tooltip.hover :title="`Sync with file name|Synchroniser avec le nom du fichier`|tr" >
                                    <i class="fas fa-rotate"/>
                                </b-btn>
                                <b-btn size="sm" variant="light" v-if="permalinkRequirement === `optional`" @click="currentFile.permaLink = ``" v-b-tooltip.hover :title="`Remove permalink|Retirer le permalink`|tr" >
                                    <i class="fas fa-close"/>
                                </b-btn>
                            </template>
                        </b-input-group>
                        <e-form-tooltip variant="danger" v-if="!isPermalinkValid">
                            <template v-if="!permaLinkIsAvailable">{{tr(`The permalink is already in use|Le lien permanent est déjà utilisé`)}}</template>
                            <template v-else-if="currentFile.permaLink?.length < 10">{{tr(`Permalinks must be longer than 10 characters.|Le lien permanent doit comporter plus de 10 caractères.`)}}</template>
                            <template v-else>{{tr(`The permalink is required|Le lien permanent requis`)}}</template>
                        </e-form-tooltip>
                    </b-form-group>
                    <b-form-group v-if="currentFile.category === 'image-360'" label-cols-md="3" label="Offset angle">
                        <div class="w-50">
                            <b-form-input v-model.number="currentFile.offsetAngle" placeholder="0" type="number" min="-180" max="180" step="1"/>
                        </div>
                    </b-form-group>

                    <b-form-group v-if="currentFile.category !== 'image-360'" label-cols-md="3" :label="'Format Options|Options et format'|tr">
<!--                        <b-form-radio-group v-model="customOutputOptions" class="w-100" button-variant="outline-primary" name="radio-btn-outline" buttons @change="onCustomOptions">-->
<!--                            <b-form-radio :value="false"><span v-tr>Auto|Auto</span></b-form-radio>-->
<!--                            <b-form-radio :value="true"><span v-tr>Custom|Personnalisé</span></b-form-radio>-->
<!--                        </b-form-radio-group>-->
                        <b-input-group>
                            <b-input-group-text>
                                <i class="fas" :class="customOutputOptions ? 'fa-cog' : 'fa-wand-magic-sparkles'"/>
                            </b-input-group-text>
                            <b-select v-model="customOutputOptions" @change="onCustomOptions">
                                <option :value="null" v-tr>Auto Optimize|Optimiser automatiquement</option>
                                <option value="custom" v-tr>Customized|Personnalisé</option>
                            </b-select>
                        </b-input-group>

                        <b-card v-if="customOutputOptions === 'custom'" class="border mt-2">
                            <b-form-group label-cols-md="3" :label="'Convert to|Convertir vers'|tr">
                                <div class="w-50">
                                    <b-input-group>
                                        <b-select v-model="outputOptions.convertTo">
                                            <option :value="null" v-tr>No conversion|Pas de conversion</option>
                                            <option value="image/webp" v-tr>WEBP</option>
                                            <option value="image/avif" v-tr>AVIF</option>
                                            <option value="image/png" v-tr>PNG</option>
                                            <option value="image/jpeg" v-tr>JPG</option>
                                        </b-select>
                                    </b-input-group>
                                </div>
                            </b-form-group>
                            <b-form-group label-cols-md="3" :label="'Image Quality|Qualité de l\'image'|tr">
                                <b-select v-model="outputOptions.quality" class="w-50">
                                    <option :value="null" v-tr>Automatic|Automatique</option>
                                    <option value="100">100%</option>
                                    <option v-for="i in 9" :value="(10 - i) * 10">{{(10 - i) * 10}}%</option>
                                </b-select>
                            </b-form-group>
                            <b-form-group label-cols-md="3" :label="'Max Size|Taille Max'|tr">
                                <b-input-group class="w-50">
                                    <b-input-group-text class="bg-white">
                                        <b-form-checkbox v-model="outputOptions.maxSizeEnabled" switch style="min-height: 0" />
                                    </b-input-group-text>
                                    <b-form-input v-model="outputOptions.maxSize" :disabled="!outputOptions.maxSizeEnabled" :placeholder="maxSize.toString()" type="number" min="0" step="1"></b-form-input>
                                    <b-input-group-text class="bg-white">px</b-input-group-text>
                                </b-input-group>
                            </b-form-group>
                        </b-card>
                    </b-form-group>

                    <template v-if="feedback.visible">
                        <b-alert :variant="feedback.icon" show class="mb-0">
                            <b-media>
                                <template #aside>
                                    <b-avatar size="48px" src="https://eyeinlivestorage.blob.core.windows.net/public/eye-intelligence/virtual-assistant/virtual-assistant.png"/>
                                </template>
                                <h5 class="mt-0">{{feedback.title}}</h5>
                                <div>{{feedback.text}}</div>
                            </b-media>
                        </b-alert>
                    </template>
                </b-media>
                <div class="w-100 d-flex modal-footer">
                    <div class="mr-auto">
                        <span class="mr-4">{{currentFile.size|unitBits}}</span>
                        {{currentFile.width}} x {{currentFile.height}}px
                    </div>
                    <b-btn variant="light" class="mr-2" @click="resetUpload">
                        <span v-tr>Cancel|Annuler</span>
                    </b-btn>
                    <b-btn variant="primary" @click="newUpload ? upload(newUpload) : save()" :disabled="loading">
                        <i v-if="loading" class="fa-solid fa-spinner fa-spin-pulse mr-1"></i>
                        <span v-if="newUpload" v-tr>Upload|Téléverser</span>
                        <span v-else v-tr>Save|Enregistrer</span>
                    </b-btn>
                </div>
            </b-tab>
            <b-tab v-else :title="`Import List|Liste d'importation`|tr">
                <e-browser v-model="importSelected" :items="filesToUpload" :fields="multipleImportFields" :key="2"
                           title="Library|Bibliothèque" thumbnail="thumbnail" :translucent="false" header-variant="light"
                           no-actions no-options forced-view="list" class="overflow-auto" style="max-height: 400px" no-rounded-border
                           @item-opened="previewBase64Image(importSelected.name, importSelected.thumbnailLarge)" @item-dropped="onFilesDropped">
                    <template #context="{item}">
                        <template v-if="item">
                            <b-dropdown-item @click="previewBase64Image(item.name, item.thumbnailLarge)">
                                <i class="fas fa-magnifying-glass"/>
                                <span v-tr>Preview|Aperçu</span>
                            </b-dropdown-item>
                            <b-dropdown-divider/>
                            <b-dropdown-item variant="danger" @click="removeFromImportList(item)">
                                <i class="fas fa-trash"/>
                                <span v-tr>Remove|Supprimer</span>
                            </b-dropdown-item>
                        </template>
                    </template>
                    <template #field_size="{data}">
                        {{data|fileSize}}
                    </template>
                    <template #item-count>
                        <div class="d-flex">
                            <span class="f-500 text-nowrap">{{ filesToUpload.length }} / {{ pendingFiles.length }} <span v-tr>items|éléments </span></span>
                            <div class="w-100 text-center d-inline-block">
                                <i v-if="!isMultipleFilesPendingFinished" class=" fa-solid fa-spinner fa-spin-pulse"></i>
                            </div>
                        </div>
                    </template>
                </e-browser>
                <div class="modal-footer w-100 text-right">
                    <b-btn variant="light" class="mr-2" @click="resetUpload">
                        <span v-tr>Cancel|Annuler</span>
                    </b-btn>
                    <b-btn variant="primary" class="" @click="multipleUpload" :disabled="!isMultipleFilesPendingFinished || filesToUpload.length === 0">
                        <i v-if="!isMultipleFilesPendingFinished" class="fa-solid fa-spinner fa-spin-pulse mr-1"></i>
                        <span v-tr>Upload {{filesToUpload.length}} files|Télécharger les {{filesToUpload.length}} fichiers</span>
                    </b-btn>
                </div>
            </b-tab>
        </b-tabs>

        <template v-if="!currentFile && tabIndex === 0" #modal-footer>
            <div class="text-right">
                <b-btn variant="light" class="mr-2" @click="close">
                    <span v-tr>Cancel|Annuler</span>
                </b-btn>
                <b-btn @click="selectFile(fileSelected)" :disabled="!fileSelected" variant="primary"><span v-tr>Select|Sélectionner</span></b-btn>
            </div>
        </template>

        <e-iframe-dialog v-if="preview.enabled && preview.type === `image`" v-model="preview.visible" preset="media-preview" :url="preview.file.url"/>
        <b-modal v-else-if="preview.enabled && preview.type === `360`" v-model="preview.visible"
                 :title="`360 Image Preview|Apercu de l'image 360`|tr" size="xl"
                 modal-class="image-360-viewer-modal" body-class="p-0" hide-footer>
            <image-360-viewer :src="preview.file.url"/>
        </b-modal>

    </b-modal>
</template>

<script>
import swal from "sweetalert";
import EBrowser from "./e-browser.vue";
import EDealerSelect from "./e-dealer-select.vue";
import EFileInput from "./e-file-input.vue";
import EInput from "./e-input.vue";
import FileHelper from "../helpers/FileHelper.js";
import Network from "../helpers/Network.js";
import EIframeDialog from "./e-iframe-dialog.vue";
import EFormTooltip from "./e-form-tooltip.vue";
import {formatPermaLink} from "../helpers/utils.js";
import EHint from "./e-hint.vue";
import Image360Viewer from "./image-360-viewer.vue";

// e-file-library #hot-reload-debug
    export default {
        name: `e-file-library`,
        components: {Image360Viewer, EHint, EFormTooltip, EDealerSelect, EIframeDialog, EBrowser, EFileInput, EInput},
        props: {
            value: {},
            file: {},
            selectedId: null,
            dealer: { type: String }, // useful when working with Eye-In Wireless users
            source: {type: String, default: `eye-intelligence`}, // to separate resources
            type: { type: String, default: `image` },
            category: { type: String, default: `default` }, // default|doc|image|icon|logo|avatars|favicon|image-360
            returnObject: { type: Boolean },
            returnMetaInfo: { type: Boolean },
            autoCompress: { type: Boolean },
            autoCompressOptions: {
                type: Object,
                default: () => {
                    return {
                        convertTo: `image/webp`,
                        quality: 80,
                        maxSize: 1024,
                        maxSizeEnabled: true
                    }
                }
            },
            allowAll: { type: Boolean },
            visible: { type: Boolean },
            permalinkRequirement: { type: String, default: `optional` }, // optional|required|disabled
            altRequirement: { type: String, default: `required` }, // optional|required|disabled
            defaultSrc: { type: String },
            defaultEditMode: { type: Boolean },
            sourceId: {},
            mapItem: {},
            openWithExternalButton: { type: Boolean },
            initialSearch: { type: String, default: `` },
            maxResolution: {type: Number, default: 2048},
            maxImageSize: {type: Number, default: 4096}, // 4Mo
            maxVideoSize: {type: Number, default: 15000} // 15Mo
        },
        data() {
            return {
                loading: false,
                tabIndex: 0,
                customUrl: ``,
                newUpload: null,
                filesToUpload: [],
                pendingFiles: [],
                preview: {
                    enabled: false,
                    visible: false,
                    type: `image`, // image|360
                    file: null
                },
                outputOptions: {
                    convertTo: null,
                    quality: null,
                    maxSize: null,
                    maxSizeEnabled: false
                },
                customOutputOptions: null,
                openProperties: false,
                renameModal: false,
                permaLinkIsAvailable: false,
                filenameIsAvailable: true,
                fileSelected: null,
                importSelected: null,
                fileCopy: null,
                renameValue: ``,
                filters: {
                    category: `all`,
                    source: `all`
                },
                library: [],
                fields: [
                    {key: `name`, label: this.tr(`Name|Nom`), sortable: true},
                    {key: `dealerid`, label: this.tr(`Venue|Compte`), hidden: true, style: { 'max-width': `100px` }},
                    {key: `type`, label: this.tr(`Type|Type`), sortable: true, style: { 'max-width': `80px` }},
                    {key: `duration`, label: this.tr(`Duration|Durée`), sortable: true, style: { 'max-width': `100px` }},
                    {key: `width`, label: this.tr(`Width|Largeur`), sortable: true, style: { 'max-width': `100px` }},
                    {key: `height`, label: this.tr(`Height|Hauteur`), sortable: true, style: { 'max-width': `100px` }},
                    {key: `size`, label: this.tr(`Size|Taille`), sortable: true, style: { 'max-width': `100px` }},
                    {key: `dateCreation`, label: this.tr(`Creation|Création`), sortable: true, hidden: true, style: { 'max-width': `130px` }},
                    {key: `dateEdition`, label: this.tr(`Last edition|Modification`), sortable: true, style: { 'max-width': `130px` }},
                    {key: `editedBy`, label: this.tr(`Edited By|Modifié par`), sortable: true, style: { 'max-width': `130px` }}
                ],
                multipleImportFields: [
                    {key: `name`, label: this.tr(`Name|Nom`), sortable: true},
                    {key: `type`, label: this.tr(`Type|Type`), sortable: true, style: { 'max-width': `80px` }},
                    {key: `category`, label: this.tr(`Category|Categorie`), sortable: true, style: { 'max-width': `120px` }},
                    {key: `extension`, label: this.tr(`Extension|Extension`), sortable: true, style: { 'max-width': `120px` }},
                    {key: `width`, label: this.tr(`Width|Largeur`), sortable: true, style: { 'max-width': `100px` }},
                    {key: `height`, label: this.tr(`Height|Hauteur`), sortable: true, style: { 'max-width': `100px` }},
                    {key: `size`, label: this.tr(`Size|Taille`), sortable: true, style: { 'max-width': `100px` }}
                ],
                feedback: {
                    visible: false,
                    title: ``,
                    text: ``,
                    icon: `info`
                }
            }
        },
        computed: {
            internalValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit(`input`, value);
                }
            },
            extractedId() {
                if (this.type === `image` && this.value && typeof this.value === `string`) {
                    // Split the URL into parts by '/'
                    const parts = this.value.split(`/`);
                    // The ID is the second to last part (before the filename)
                    return parts[parts.length - 2];
                }
                return null;
            },
            currentDealerid() {
                return this.dealer ? this.dealer : this.dealerid;
            },
            visibilityComputed: {
                get() {
                    return this.visible;
                },
                set(value) {
                    this.$emit(`update:visible`, value);
                }
            },
            currentFile: {
                get() {
                    return this.newUpload || this.fileCopy
                },
                set(value) {
                    if (this.fileCopy) {
                        this.fileCopy = value;
                    } else {
                        this.newUpload = value;
                    }
                }
            },
            maxSize() {
                return Math.max(this.currentFile?.width, this.currentFile?.height);
            },
            libraryFiltered() {
                if (this.filters.category === `all` && this.filters.source === `all`) {
                    return this.library;
                } else {
                    return this.library.filter(f => {
                        if (f.category !== this.filters.category && this.filters.category !== `all`) {
                            return false;
                        }
                        if (f.source !== this.filters.source && this.filters.source !== `all`) {
                            return false;
                        }
                        return true;
                    });
                }
            },
            isImportMultiple() {
                return this.pendingFiles?.length > 0 || this.filesToUpload?.length > 0;
            },
            isMultipleFilesPendingFinished() {
                return this.filesToUpload?.length === this.pendingFiles?.length;
            },
            isPermalinkValid() {
                if (this.permalinkRequirement === `disabled`)
                    return true;

                if (!this.permaLinkIsAvailable)
                    return false;

                if (!this.currentFile.permaLink && this.permalinkRequirement === `required`)
                    return false;

                return !this.currentFile.permaLink || this.currentFile.permaLink.length >= 10;
            },
            isFilenameValid() {
                if (!this.filenameIsAvailable)
                    return false;

                if (!this.currentFile.name)
                    return false;

                return this.currentFile.name.length >= 1;
            },
            fileCategory() {
                if (this.filters.category === `all`) {
                    return this.category;
                } else {
                    return this.filters.category;
                }
            }
        },
        created() {
            this.getLibrary()
            if (this.category === `default`) {
                this.filters.category = `all`;
            } else {
                this.filters.category = this.category;
            }
            this.filters.source = this.source || `all`;
        },
        methods: {
            async checkIfPermaLinkIsNotUsed() {
                if (!this.currentFile) {
                    return false;
                }

                if (this.permalinkRequirement === `disabled`) {
                    this.currentFile.permaLink = null;
                    return false;
                }

                if (this.currentFile.permaLink?.length >= 10) {
                    try {
                        const permaLink = this.currentFile.permaLink;
                        this.permaLinkIsAvailable = await this.getIfPermalinkAvailable(permaLink);
                    } catch (e) {
                        this.permaLinkIsAvailable = false;
                    }
                } else {
                    this.permaLinkIsAvailable = true;
                }

                this.currentFile.permaLink = formatPermaLink(this.currentFile.permaLink);
            },
            async checkIfFileNameIsNotUsed() {
                if (!this.currentFile) {
                    return false;
                }

                try {
                    const filename = this.currentFile.name;
                    this.filenameIsAvailable = await this.getIfFilenameAvailbale(filename);
                } catch (e) {
                    this.filenameIsAvailable = false;
                }
            },
            async getIfPermalinkAvailable(permaLink) {
                const resp = await Network.get(`/library/files/check-perma-link/${this.currentDealerid}/${permaLink}`, null, {system_api: true});
                return resp.data === false;
            },
            async getIfFilenameAvailbale(filename) {
                const resp = await Network.get(`/library/files/check-file-name/${this.currentDealerid}/${filename}`, null, {system_api: true});
                return resp.data === false;
            },
            syncPermaLinkWithFileName() {
                if (this.permalinkRequirement === `disabled`) {
                    this.currentFile.permaLink = null;
                } else {
                    this.currentFile.permaLink = formatPermaLink(this.currentFile.name);
                }
            },
            getLibrary() {
                Network.get(`/library/files/list/${this.currentDealerid}`, null, {system_api: true})
                    .then(resp => {
                        this.library = resp.data;
                        this.initProperties();
                    });
            },
            resetUpload() {
                if (this.$refs.file) {
                    this.$refs.file.reset();
                }
                this.pendingFiles = [];
                this.filesToUpload = [];
                this.newUpload = null;
                this.fileCopy = null;
                this.customOutputOptions = null;

                if (this.autoCompress) {
                    this.outputOptions.maxSize = this.autoCompressOptions.maxSize;
                    this.outputOptions.maxSizeEnabled = this.autoCompressOptions.maxSizeEnabled;
                    this.outputOptions.convertTo = this.autoCompressOptions.convertTo;
                    this.outputOptions.quality = this.autoCompressOptions.quality;
                } else {
                    this.outputOptions = {
                        convertTo: null,
                        quality: null,
                        maxSize: null,
                        maxSizeEnabled: false
                    };
                }

                this.openProperties = false;
                requestAnimationFrame(() => {
                    this.tabIndex = 0;
                });
            },
            reduceFile(file, onlyMetadata = false) {
                if (onlyMetadata) {
                    return {
                        id: file.id,
                        name: file.name,
                        alt: file.alt,
                        category: file.category,
                        url: file.url,
                        offsetAngle: file.offsetAngle,
                        width: file.width,
                        height: file.height,
                        revision: file.revision
                    }
                }
                return {
                    id: file.id,
                    name: file.name,
                    alt: file.alt,
                    extension: file.extension,
                    size: file.size,
                    type: file.type,
                    thumbnail: file.thumbnail,
                    thumbnailLarge: file.thumbnailLarge,
                    url: file.url,
                    width: file.width,
                    height: file.height,
                    offsetAngle: file.offsetAngle
                }
            },
            selectFile(file) {
                if (this.returnMetaInfo || this.returnObject) {
                    const returnObject = this.reduceFile(file, this.returnMetaInfo);
                    this.$emit(`input`, returnObject);
                    this.$emit(`selected`, returnObject);
                } else {
                    this.$emit(`input`, file.url);
                    this.$emit(`selected`, file.url);
                }
                this.$emit(`file-selected`, file);
                this.$emit(`update:file`, file);
                this.close();
            },
            async urlToFile(url) {
                const file = await FileHelper.loadImageWithProxyAsFile(url);
                await this.onNewUpload(file);
            },
            useURL() {
                this.$emit(`input`, this.customUrl);
                this.visibilityComputed = false;
                this.$emit(`close`);
            },
            show() {
                this.initProperties();
                this.visibilityComputed = true;
                this.$emit(`show`);
            },
            close() {
                this.resetUpload();
                this.visibilityComputed = false;
                this.$emit(`close`);
            },
            initProperties() {
                if (this.library.length === 0) {
                    return;
                }

                if (this.defaultEditMode) {
                    this.setDefaultProperties();
                } else if (!this.openWithExternalButton) {
                    this.resetUpload();
                }

                if (this.extractedId) {
                    const fileIndex = this.library.findIndex(f => f.id === this.extractedId);
                    if (fileIndex !== -1) {
                        this.fileSelected = this.library[fileIndex];
                    }
                }
            },
            onFileDropped(item, event) {
                event.preventDefault();
                const file = event.dataTransfer.files[0];
                this.onNewUpload(file);
            },
            onFilesDropped(item, event) {
                event.preventDefault();
                const files = [...event.dataTransfer.files];
                if (files.length > 0 && files.length <= 1) {
                    this.onFileDropped(item, event);
                } else {
                    this.pendingFiles.push(...files);
                    for (let index = 0; index < files.length; index++) {
                        this.onNewUpload(files[index])
                            .then(upload => {
                                this.filesToUpload.push(upload);
                            })
                            .catch(() => {
                                this.showErrorMessage();
                            })
                    }
                }
            },
            renameItem() {
                if (this.renameValue === this.fileSelected.name) {
                    this.renameModal = false;
                    return;
                }
                Network.patch(`/library/files/rename`, {
                    id: this.fileSelected.id,
                    newName: this.renameValue
                }, { system_api: true })
                    .then(() => {
                        this.fileSelected.name = this.renameValue;
                        this.$forceUpdate();
                    }).catch(() => {
                    this.showErrorMessage();
                });
            },
            onItemOpened(event) {
                this.fileCopy = JSON.parse(JSON.stringify(this.fileSelected || this.importSelected));
                this.openProperties = true;
                this.feedback.visible = false;
            },
            onNextUpload() {
                this.upload(this.newUpload);
            },
            async onNewUpload(file) {
                if (!file) {
                    return Promise.reject();
                }

                const newUpload = {
                    dealerid: this.currentDealerid,
                    source: this.source,
                    file: file,
                    alt: null,
                    permaLink: null,
                    name: FileHelper.getFileName(file.name),
                    type: FileHelper.getFileType(file.name),
                    extension: FileHelper.getFileExtension(file.name),
                    size: file.size,
                    showInLibrary: true,
                    category: this.fileCategory
                }
                if (newUpload.type === `unknown`) {
                    this.showErrorMessage(`File not supported|Fichier non supporté`, `This type of file extension is not supported yet|Ce type d'extension de fichier n'est pas supporté pour le moment`);
                    return Promise.reject();
                }

                if (this.altRequirement !== `disabled`) {
                    newUpload.alt = FileHelper.getFileName(file.name);
                }

                if (this.permalinkRequirement !== `disabled`) {
                    newUpload.permaLink = formatPermaLink(FileHelper.getFileName(file.name));
                }

                if (this.sourceId) {
                    newUpload.sourceid = this.sourceId;
                }
                this.feedback.visible = false;

                setTimeout(() => {
                    this.checkIfPermaLinkIsNotUsed();
                }, 100);

                if (newUpload.type === `image` || newUpload.type === `video`) {
                    return this.generateThumbnail(newUpload)
                        .then(() => {
                            this.newUpload = newUpload;
                            return newUpload;
                        })
                        .catch(e => {
                            this.showErrorMessage();
                            return Promise.reject(e);
                        });
                } else {
                    // do not generate thumbnail on other type of content
                    this.newUpload = newUpload;
                    this.newUpload.thumbnail = FileHelper.getFileIcon(newUpload);
                    return this.newUpload;
                }
            },
            generateThumbnail(file) {
                return new Promise((resolve, reject) => {
                    this.loading = true;

                    const handleImage = (image) => {
                        file.width = image.width;
                        file.height = image.height;

                        // Change file category to image-360 if the image width is 5504 or 11008
                        if (file.width === 5504 || file.width === 11008) {
                            file.category = `image-360`;
                        }

                        this.feedback.visible = false;

                        if (file.category === `image`) {
                            if (file.width > this.maxResolution || file.height > this.maxResolution) {
                                if (file.width > file.height) {
                                    file.height = Math.round(file.height / Math.round(file.width / this.maxResolution));
                                    file.width = this.maxResolution;
                                } else {
                                    file.width = Math.round(file.width / Math.round(file.height / this.maxResolution));
                                    file.height = this.maxResolution;
                                }
                                this.$set(this, `feedback`, {
                                    visible: true,
                                    title: this.tr(`File is Too Big|Le fichier est trop grand`),
                                    text: this.tr(`It will be resized automatically to ${file.width}*${file.height}px.|Il sera redimensionné automatiquement en ${file.width}*${file.height}px.`),
                                    icon: `info`
                                });
                            } else if (file.size > this.maxImageSize * 1000) {
                                this.$set(this, `feedback`, {
                                    visible: true,
                                    title: this.tr(`File is Too Heavy|Le fichier est trop lourd`),
                                    text: this.tr(`It will be compressed automatically to load faster. We recommend to use maximum 500KB files.|Il sera compressé automatiquement pour charger plus vite. Nous recommendons de ne pas dépasser 500KB`),
                                    icon: `info`
                                });
                            }
                        }

                        if (image.width < 300 && image.height < 300) {
                            this.$set(file, `thumbnail`, FileHelper.createThumbnail(image, Math.max(image.width, image.height)));
                        } else {
                            this.drawThumbnail(file, image);
                            this.drawThumbnail(file, image, true);
                        }
                        this.loading = false;
                        resolve();
                    };

                    switch (file.type) {
                        case `image`:
                        case `image-360`:
                            FileHelper.loadImageFromFile(file.file)
                                .then(handleImage)
                                .catch(reject);
                            break;
                        case `video`:
                            FileHelper.loadVideoFromFile(file, (el) => this.drawThumbnail(file, el))
                                .then(video => {
                                    file.duration = Math.round(video.duration);
                                    file.height = Math.round(video.videoHeight);
                                    file.width = Math.round(video.videoWidth);
                                    this.loading = false;
                                    resolve();
                                })
                                .catch(reject);
                            break;
                        default:
                            this.loading = false;
                            reject();
                    }
                });
            },
            applyOutputOptions(file) {
                if ((this.customOutputOptions === `custom` && file.category !== `image-360`) || this.autoCompress) {
                    const { convertTo, quality, maxSize } = this.outputOptions;

                    if (maxSize) {
                        file.maxSize = +maxSize;
                    }
                    if (convertTo) {
                        file.convertTo = convertTo;
                    }
                    if (quality) {
                        file.quality = +quality;
                    }
                }
            },
            drawThumbnail(file, element, large = false) {
                if (large) {
                    this.$set(file, `thumbnailLarge`, FileHelper.createThumbnail(element, 500));
                } else {
                    this.$set(file, `thumbnail`, FileHelper.createThumbnail(element));
                }
            },
            async multipleUpload() {
                const totalFiles = this.filesToUpload.length;
                let uploadedFiles = 0;
                this.showLoading();
                try {
                    while (this.filesToUpload.length > 0) {
                        const file = this.filesToUpload[0];
                        const resp = await Network.post(`/library/files/create`, file, {
                            process_files: true, system_api: true, timeout: 10 * 60 * 1000
                        });
                        this.library.push(resp.data);
                        this.filesToUpload.shift();
                        uploadedFiles++;
                        const percent = (uploadedFiles / totalFiles) * 100;
                        this.showLoading(null, null, percent);
                        console.log(`uploaded: ` + file.name);
                    }
                    this.getLibrary();
                    this.resetUpload();
                    this.showSavedMessage(`All files uploaded successfully|Tous les fichiers ont été téléchargés avec succès`);
                } catch (error) {
                    console.error(`Error uploading files:`, error);
                    this.getLibrary();
                    this.showErrorMessage();
                }
            },
            save() {
                this.showLoading();
                this.applyOutputOptions(this.currentFile);

                // If the file as been customized with output options but not re-uploaded
                const shouldReUpload = !this.currentFile.file && (!!this.currentFile.quality || !!this.currentFile.convertTo || !!this.currentFile.maxSize);
                // We need to fetch the current file to send it again
                if (shouldReUpload) {
                    fetch(this.currentFile.url).then(res => res.blob())
                        .then(blob => {
                            this.currentFile.file = new File([blob], this.currentFile.name, {type: blob.type});
                            this.patchFilesProperties();
                        })
                        .catch(error => {
                            console.error(`Error fetching the file from URL:`, error);
                            this.showErrorMessage();
                        });
                } else {
                    this.patchFilesProperties();
                }
            },
            removeFromImportList(file) {
                const index = this.filesToUpload.findIndex(item => item.name === file.name);
                if (index !== -1) {
                    this.filesToUpload.splice(index, 1);
                    this.pendingFiles.splice(index, 1);
                }
                if (this.filesToUpload.length === 0) {
                    this.resetUpload();
                }
            },
            /*
            CREATE & SAVE
             */
            upload(file) {
                this.showLoading();
                this.applyOutputOptions(file);

                if (this.permalinkRequirement === `disabled`) {
                    this.currentFile.permaLink = null;

                    if (this.currentFile.storageUrl) {
                        this.currentFile.url = this.currentFile.storageUrl;
                    }
                }

                console.log(`start upload`);
                Network.post(`/library/files/create`, file, {
                    process_files: true, system_api: true
                })
                    .then(resp => {
                        this.library.push(resp.data);
                        console.log(`uploaded: ` + file.name);
                        this.selectFile(resp.data);
                        this.getLibrary()
                        this.resetUpload()
                        console.log(`end upload`);
                        this.hideLoading();
                    })
                    .catch(e => {
                        this.showErrorMessage();
                        console.error(e);
                    })
            },
            patchFilesProperties() {
                const shouldProcessFile = !!this.currentFile.file;
                this.currentFile.changeThumbnail = !!this.currentFile.file;

                if (this.permalinkRequirement === `disabled`) {
                    this.currentFile.permaLink = null;

                    if (this.currentFile.storageUrl) {
                        this.currentFile.url = this.currentFile.storageUrl;
                    }
                }

                Network.patch(`/library/files/update`, this.currentFile, {
                    process_files: shouldProcessFile, system_api: true
                })
                    .then((resp) => {
                        const index = this.library.findIndex(item => item.id === resp.data.id);
                        if (index !== -1) {
                            this.library.splice(index, 1, { ...this.library[index], ...resp.data });
                        } else {
                            this.library.push(resp.data);
                        }
                        this.selectFile(resp.data);
                        this.resetUpload()
                        this.hideLoading();
                    })
                    .catch(e => {
                        this.showErrorMessage();
                        console.error(e);
                    })
                    .finally(() => this.currentFile = null)
            },
            onUpdateFile(file) {
                if (!file) {
                    return;
                }

                if (FileHelper.getFileType(file.name) !== this.currentFile.type) {
                    return;
                }
                const { id, name, alt, type, category, description, permaLink, source } = this.currentFile;
                this.currentFile = {
                    id,
                    name,
                    alt,
                    category,
                    description,
                    permaLink,
                    dealerid: this.dealerid,
                    source: this.source,
                    sourceId: this.sourceId,
                    file: file,
                    type: type,
                    extension: FileHelper.getFileExtension(file.name),
                    size: file.size,
                    showInLibrary: true
                }

                if (source) {
                    this.currentFile.source = source;
                    this.currentFile.sourceId = null;
                }

                this.generateThumbnail(this.currentFile);
            },
            /*
             * 360 image editor
             */
            previewFile(file) {
                this.preview.visible = true;
                this.preview.enabled = true;
                this.preview.type = `image`;
                this.preview.file = file;
                if (file?.category === `image-360` && file.url) {
                    this.preview.type = `360`;
                }
            },
            previewBase64Image(title, url) {
                swal({
                    title: title,
                    content: {
                        element: `img`,
                        attributes: {
                            width: `450`,
                            src: url,
                            alt: title
                        }
                    }
                })
            },
            setDefaultProperties() {
                this.fileCopy = this.library.find(f => f.id === this.value.id);
                this.openProperties = true;
            },
            onCustomOptions(value) {
                if (value !== `custom`) {
                    if (this.autoCompress) {
                        this.outputOptions.maxSize = this.autoCompressOptions.maxSize;
                        this.outputOptions.maxSizeEnabled = this.autoCompressOptions.maxSizeEnabled;
                        this.outputOptions.convertTo = this.autoCompressOptions.convertTo;
                        this.outputOptions.quality = this.autoCompressOptions.quality;
                    } else {
                        this.outputOptions = {
                            convertTo: null,
                            quality: null,
                            maxSize: null,
                            maxSizeEnabled: false
                        };
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
.e-file-library.modal {
    .modal-content {
        .modal-body {
            background: #fafafa;
            color: #333;
        }

        .modal-footer {
            border-top: 1px solid rgba(black, 0.15);
            background: #fff;
        }
    }
}

</style>
<style lang="scss" scoped>
.gap-1 {
    gap: 0.25rem;
}
.btn-outline-primary {
    color: #257c28;
    border: 1px solid #257c28;
    box-shadow: none;
    transition: none;

    &.active {
        color: white;
        border: 1px solid #257c28;
        background: linear-gradient(8deg, #4CAF50 0%, #009688 100%);
    }

    &:hover {
        color: white;
        background: linear-gradient(8deg, #72d576 0%, #009688 100%);
    }

    &:focus,
    &:active {
        color: white;
        background: linear-gradient(8deg, #257c28 0%, #009688 100%);
    }
}
</style>
